<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="wp">
            <div class="formw01" style="padding-top: .15rem">
                <div class="infow01-lab">
                    <div class="lab">认证信息</div>
                </div>
                <div v-if="type == 'kaifashang'">
                    <div class="infow01-val">
                        <div class="formw01-item">
                            <div class="formw01-lab">真实姓名<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="realname" placeholder="请输入真实姓名">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">身份证号码<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="dcard" placeholder="请输入身份证号码">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">公司名称<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="company_name" placeholder="请输入公司名称">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">职务<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="job" placeholder="请输入职务">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">名片正面<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <label class="formw01-file">
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" data-type="business_card_front" @change="addFile"><span class="bg">名片正面</span>
                                    <img :src="business_card_front" alt="" class="pic">
                                </label>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">名片反面<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <label class="formw01-file">
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" data-type="business_card_back" @change="addFile"><span class="bg">名片反面</span>
                                    <img :src="business_card_back" alt="" class="pic">
                                </label>
                            </div>
                        </div>
                        <div class="formw01-tip">
                            <p>温馨提示</p>
                            <p>认证经纪人可发布房源信息，认证开发商可发布楼盘信息。</p>
                            <p>同一ID只能认证一种身份，需要更改身份请拨打网站电话400-0080-960。</p>
                        </div>
                        <div class="formw01-item-ft">
                            <div class="btn s1" @click="resetEdit">取　消</div>
                            <div class="btn s2" @click="Certified">提　交</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="infow01-val">
                        <div class="formw01-item">
                            <div class="formw01-lab">真实姓名<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="realname" placeholder="请输入真实姓名">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">身份证号<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="dcard" placeholder="请输入身份证号">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">公司名称<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <input class="formw01-inp" type="text" v-model="company_name" placeholder="请输入公司名称">
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab">服务区域</div>
                            <div class="formw01-val">
                                <select class="formw01-sel" ref="province0" name="province0" @change="initCity(0)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in provinceArr" :value="name" :selected="name == province_id_arr[0]">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="city0" name="city0" @change="initArea(0)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in cityArr[0]" :value="name" :selected="name == province_id_arr[0]">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="area0" name="area0" @change="selectArea(0)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in areaArr[0]" :value="name" :selected="name == province_id_arr[0]">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab"></div>
                            <div class="formw01-val">
                                <select class="formw01-sel" ref="province1" name="province1" @change="initCity(1)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in provinceArr" :value="name" :selected="name == province_id_arr[1]">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="city1" name="city1" @change="initArea(1)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in cityArr[1]" :value="name" :selected="name == province_id_arr[1]">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="area1" name="area1" @change="selectArea(1)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in areaArr[1]" :value="name" :selected="name == province_id_arr[1]">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab"></div>
                            <div class="formw01-val">
                                <select class="formw01-sel" ref="province2" name="province2" @change="initCity(2)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in provinceArr" :value="name" :selected="name == province_id_arr[2]">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="city2" name="city2" @change="initArea(2)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in cityArr[2]" :value="name" :selected="name == province_id_arr[2]">{{ item }}</option>
                                </select>
                                <select class="formw01-sel" ref="area2" name="area2" @change="selectArea(2)">
                                    <option value="-1" selected>请选择</option>
                                    <option v-for="(item, name, index) in areaArr[2]" :value="name" :selected="name == province_id_arr[2]">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab"></div>
                            <div class="formw01-val">
                                <div class="formw01-tip">温馨提示:至少选择一个服务区域。</div>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">身份证<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <label class="formw01-file">
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" data-type="idcard_front" @change="addFile"><span class="bg">身份证正面</span>
                                    <img :src="idcard_front" alt="" class="pic">
                                </label>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">身份证<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <label class="formw01-file">
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" data-type="idcard_back" @change="addFile"><span class="bg">身份证反面</span>
                                    <img :src="idcard_back" alt="" class="pic">
                                </label>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">从业资格证<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <label class="formw01-file">
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" data-type="qualification_certificate" @change="addFile"><span class="bg">从业资格证</span>
                                    <img :src="qualification_certificate" alt="" class="pic">
                                </label>
                            </div>
                        </div>
                        <div class="formw01-item">
                            <div class="formw01-lab valign-top">营业执照<i class="strongTip">*</i></div>
                            <div class="formw01-val">
                                <label class="formw01-file">
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" data-type="business_license" @change="addFile"><span class="bg">营业执照</span>
                                    <img :src="business_license" alt="" class="pic">
                                </label>
                            </div>
                        </div>
                        <div class="formw01-tip">
                            <p>温馨提示</p>
                            <p>认证经纪人可发布房源信息，认证开发商可发布楼盘信息。</p>
                            <p>同一ID只能认证一种身份，需要更改身份请拨打网站电话400-0080-960。</p>
                        </div>
                        <div class="formw01-item-ft">
                            <div class="btn s1" @click="resetEdit">取　消</div>
                            <div class="btn s2" @click="Certified">提　交</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Http from '@/libs/http.js'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Popup, Picker, Toast } from 'vant'
    export default {
        name: "Certification",
        data: function () {
            return {
                type: this.$route.query.type,
                realname: '',
                dcard: '',
                company_name: '',
                idcard_front: '',
                idcard_back: '',
                qualification_certificate: '',
                business_license: '',
                business_card_front: '',
                business_card_back: '',
                job: '',
                provinceArr: [{}, {}, {}],
                cityArr: [{}, {}, {}],
                areaArr: [{}, {}, {}],
                province_id_arr: [],
                city_id_arr: [],
                area_id_arr: []
            }
        },
        components: {
            Header, Footer,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Toast.name]: Toast
        },
        mounted () {
            this.selProvice();
        },
        methods: {
            resetEdit () {
                this.$router.back();
            },
            selProvice () {
                let result = {};
                const _this = this;
                _this.api.getProvinces().then(function(response){
                    for (let i in response) {
                        result[response[i].id] = response[i].name;
                    }
                    _this.provinceArr = result;
                })
            },
            selCity (id, index) {
                let result = {};
                const _this = this;
                _this.api.getCitys(id).then(function(response){
                    for (let i in response.area_list) {
                        result[response.area_list[i].id] = response.area_list[i].name;
                    }
                    _this.$set(_this.cityArr, index, result);
                    console.log(_this.cityArr[index])
                })
            },
            selArea (id, index) {
                let result = {};
                const _this = this;
                _this.api.getAreas(id).then(function(response){
                    for (let i in response.area_list) {
                        result[response.area_list[i].id] = response.area_list[i].name;
                    }
                    _this.$set(_this.areaArr, index, result);
                })
            },
            initCity (index) {
                let id = this.$refs['province' + index].options[this.$refs['province' + index].selectedIndex].value;
                this.province_id_arr[index] = id;
                this.$set(this.cityArr, index, []);
                this.$set(this.areaArr, index, []);
                this.selCity(id, index);
            },
            initArea (index) {
                let id = this.$refs['city' + index].options[this.$refs['city' + index].selectedIndex].value;
                this.city_id_arr[index] = id;
                this.selArea(id, index);
            },
            selectArea (index) {
                let id = this.$refs['area' + index].options[this.$refs['area' + index].selectedIndex].value;
                this.area_id_arr[index] = id;
            },
            selectVal(e){
                console.log(e)
                const _this = this;
                if (e.target.name == 'province') {
                    _this.province_id_array[e.target.dataset.index] = e.target.value;
                    _this.province_arr[e.target.dataset.index] = e.target.options.selectedIndex-1
                } else if (e.target.name == 'city') {
                    _this.city_id_array[e.target.dataset.index] = e.target.value;
                    _this.city_arr[e.target.dataset.index] = e.target.options.selectedIndex-1
                } else if (e.target.name == 'area') {
                    _this.area_id_array[e.target.dataset.index] = e.target.value-1;
                }
                console.log(_this)
            },
            Certified () {
                const _this = this;
                let param = new FormData();
                if (_this.type == 'kaifashang') {
                    param.append('type', _this.type);
                    param.append('realname', _this.realname);
                    param.append('dcard', _this.dcard);
                    param.append('business_card_front', _this.business_card_front);
                    param.append('business_card_back', _this.business_card_back);
                    param.append('company_name', _this.company_name);
                    param.append('job', _this.job);
                } else if (_this.type == 'jingjiren') {
                    param.append('type', _this.type);
                    param.append('realname', _this.realname);
                    param.append('dcard', _this.dcard);
                    param.append('company_name', _this.company_name);
                    param.append('idcard_front', _this.idcard_front);
                    param.append('idcard_back', _this.idcard_back);
                    param.append('qualification_certificate', _this.qualification_certificate);
                    param.append('business_license', _this.business_license);
                    param.append('province_id_array', _this.province_id_arr);
                    param.append('city_id_array', _this.city_id_arr);
                    param.append('area_id_array', _this.area_id_arr);
                }
                _this.api.checkBorker(param).then(function(response){
                    Toast(response.msg)
                })
            },
            addFile (e) {
                let type = e.target.dataset.type;
                let file = e.target.files[0];
                var url = null;
                if (window.createObjectURL!=undefined) {
                    url = window.createObjectURL(file) ;
                } else if (window.URL!=undefined) {
                    url = window.URL.createObjectURL(file) ;
                } else if (window.webkitURL!=undefined) {
                    url = window.webkitURL.createObjectURL(file) ;
                }
                this[type] = url;
            }
        }
    }
</script>

<style scoped>

</style>